<template>
  <BaseLanding
    :faq-id="12">
    <template #header>
      <div>{{$t('renew_header_car')}}</div>
    </template>
  </BaseLanding>
</template>

<script>
import BaseLanding from '@/components/BaseLanding.vue'

export default {
  name: 'LandingCar',
  components: {
    BaseLanding
  }
}
</script>
